module.exports = __webpack_public_path__ + "img/test.9c328d36.png";